import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getDeliveryAndQualityKpiCardData = createAsyncThunk(
  'alix/get-delivery-and-quality-kpi-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/delivery-scoreboard/kpi?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getDeliveryAcceptanceData = createAsyncThunk(
  'alix/get-delivery-acceptance-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/delivery-scoreboard/delivery-acceptance?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getSupplierLeadTime = createAsyncThunk(
  'alix/get-supplier-lead-time',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/delivery-scoreboard/supplier-lead-time?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getDeliveryEffectiveNess = createAsyncThunk(
  'alix/delivery-effectiveness',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/delivery-scoreboard/delivery-effectiveness?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getOrderFullFillment = createAsyncThunk(
  'alix/order-fulfillment',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/delivery-scoreboard/order-fulfillment?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getDeliveryRiseData = createAsyncThunk(
  'alix/delivery-rise',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/delivery-scoreboard/delivery-risk-graph?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getOTIFData = createAsyncThunk('alix/delivery-otif', async (payload, toolkit) => {
  return await AxiosClient(
    'GET',
    `/v1/risk-management/delivery-scoreboard/otif-graph?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
    {},
    toolkit,
  )
})

export const getDeliveryFillRateData = createAsyncThunk(
  'alix/delivery-fill-rate',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/delivery-scoreboard/fill-rate-graph?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getQualityKpiCardData = createAsyncThunk(
  'alix/quality-kpi',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/quality-scoreboard/kpi?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getQualityRiskScoreGraphData = createAsyncThunk(
  'alix/quality-risk-score-graph',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/quality-scoreboard/quality-risk-score-graph?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getQualityDefectivePPMData = createAsyncThunk(
  'alix/quality-defective-ppm-graph',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/quality-scoreboard/ppm-graph-data?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)
